<template>
  <TimeslotDashboardLayout>
    <div class="main-content professional">
      <!--      <div class="div-block-106">-->
      <!--        <div class="text-block-86">-->
      <!--          Your professional profile is pending approval. You will be notified-->
      <!--          when your profile has been verified.-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="welcome-wrappr">
        <!--        {{userInfo}}-->
        <div class="text-block-13">
          Hello, {{ userInfo.customerFirstName }}
          {{ userInfo.customerLastName }}
        </div>
        <div class="text-block-14">Welcome to Timeslate 👋</div>
      </div>
      <div class="profile-setup-wrapper">
        <div class="header">
          <div class="text-block-15">Let’s start with the basics 🥳</div>
        </div>
        <div class="paragraph-wrapper">
          <div
            class="paragraph"
            style="font-family: 'Galano grotesque-Medium', sans-serif; "
          >
            <!--            Complete your profile setup by providing the information below.-->
            Take the steps below to complete your profile setup
          </div>
          <div class="paragraph-copy">{{ progress }}/3 completed</div>
        </div>
        <div class="progress-bar-wrapper">
          <div
            class="progress-indicator-2"
            :style="{ width: progressWidth }"
          ></div>
        </div>
        <div class="steps">
          <FormulateInput
            type="radio"
            label="Complete your professional profile"
            name="radio-item-profile"
            :class="updateProfile ? 'progress-checked label' : 'progress-check'"
            id="personal-details"
            :value="updateProfile"
            :checked="updateProfile"
            @click="completeProfile"
          />
          <FormulateInput
            type="radio"
            label="Add account information"
            :class="updatePayment ? 'progress-checked label' : 'progress-check'"
            id="client-profile"
            name="radio-item-education"
            :value="updatePayment"
            :checked="updatePayment"
            @click="completePayment"
          />
          <FormulateInput
            type="radio"
            label="Set up your availability — a schedule you enjoy"
            name="radio-item-employment"
            :class="
              updateAvailability ? 'progress-checked label' : 'progress-check'
            "
            id="first-consultation"
            :value="updateAvailability"
            :checked="updateAvailability"
            @click="completeAvailability"
          />
        </div>
      </div>
      <div class="recent-activities">
        <div>
          <div class="text-block-82">Your activities</div>
        </div>
        <div class="div-block-101">
          <div
            id="w-node-a751f5c3-839f-5f54-3e5d-09271a432e1e-c786a4ef"
            class="_1-1booking"
          >
            <div class="div-block-103">
              <div>
                <div class="text-block-84">1:1 Bookings</div>
                <div class="text-block-85">This month: {{ bookingsTotal }}</div>
              </div>
              <div>
                <div class="text-block-83">{{ bookingsTotal }}</div>
              </div>
            </div>
          </div>
          <div
            id="w-node-_37eb175c-acf4-0330-3a58-d80ce2ccda4c-c786a4ef"
            class="earnings"
          >
            <div class="div-block-103">
              <div>
                <div class="text-block-84">Earnings</div>
                <div class="text-block-85">This month:0</div>
              </div>
              <div>
                <div class="text-block-83 earning">0</div>
              </div>
            </div>
          </div>
          <div
            id="w-node-d3b715bb-ac45-9c5c-ab60-bf538b79c3f9-c786a4ef"
            class="minutes-mentored"
          >
            <div class="div-block-103">
              <div>
                <div class="text-block-84">Minutes mentored</div>
                <div class="text-block-85">This month: {{ minutesTotal }}</div>
              </div>
              <div>
                <div class="text-block-83 minutes">{{ minutesTotal }}</div>
              </div>
            </div>
          </div>
          <div
            id="w-node-ffb5223c-31a0-4fe6-044e-36a31304cdc6-c786a4ef"
            class="div-block-102"
          >
            <div class="div-block-103">
              <div>
                <div class="text-block-84">Reviews</div>
                <div class="text-block-85">This month:{{ reviews.length }}</div>
              </div>
              <div>
                <div class="text-block-83">{{ reviews.length }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
// import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
// import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";
import CustomerRequest from "@/model/requests/CustomerRequest";
import AvailableTimeRequest from "@/model/requests/AvailableTimeRequest";
import BookingRequest from "@/model/requests/BookingRequest";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
export default {
  name: "ProfessionalDashboard",
  components: {
    // ProfessionalSidebar,
    // ProfessionalAppNavBar,
    TimeslotDashboardLayout
  },
  data() {
    return {
      bar: true,
      cross: false,
      readProfModel: ProfessionalRequest.readBy,
      readCustomerModel: CustomerRequest.readBy,
      dateModel: AvailableTimeRequest.readDates,
      bookingModel: BookingRequest.readByProfessionalId
    };
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      profBookingInfo: state => state.booking.profBookingInfo,
      profInfo: state => state.professional.professionalInfo,
      availableDates: state => state.availability.availableDates,
      reviews: state => state.professional.reviews,
      professionalId: state => state.professional.professionalId,
      customerId: state => state.customer.customerId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    updateProfile() {
      return (
        "professionalLinkedinLink" in this.profInfo &&
        "customerDisplayPicture" in this.profInfo
      );
    },
    updatePayment() {
      return (
        "payOutAccountBank" in this.profInfo &&
        "payOutAccountNumber" in this.profInfo
      );
    },
    updateAvailability() {
      return this.userInfo.availableTime.length !== 0;
    },

    setProgressBar() {
      let value = 0;
      if (this.updateProfile) {
        value += 1;
      }
      if (this.updatePayment) {
        value += 1;
      }
      if (this.updateAvailability) {
        value += 1;
      }
      return value;
    },
    progress() {
      return `${this.setProgressBar}`;
    },
    progressWidth() {
      let barWidth = this.setProgressBar * 33.34;
      return `${barWidth}%`;
    },
    bookingsTotal() {
      let upcoming = this.profBookingInfo.filter(
        item => item.bookingStatus.toLowerCase() === "upcoming"
      );
      let upLength = upcoming.length;
      let past = this.profBookingInfo.filter(
        item => item.bookingStatus.toLowerCase() === "past"
      );
      let pastLength = past.length;
      let totalLength = upLength + pastLength;
      return totalLength;
    },
    minutesTotal() {
      let past = this.profBookingInfo.filter(
        item => item.bookingStatus === "PAST"
      ).length;
      let minutes = past * 30;
      return minutes;
    }
    // earningsTotal() {
    // let past = this.profBookingInfo
    //   .filter(item => item.bookingStatus === "PAST")
    //   .map(item => item.bookingAmount);
    // const initialValue = 0;
    // let calculateEarnings = (accumulator, currentValue) =>
    //   accumulator + 0.8 * currentValue;
    // return past.reduce(calculateEarnings, initialValue);
    // }
  },
  methods: {
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    completeProfile() {
      RouterUtils.changeRouteUrlTo("/professional-settings");
    },
    completePayment() {
      RouterUtils.changeRouteUrlTo("/professional-settings");
    },
    completeAvailability() {
      RouterUtils.changeRouteUrlTo("/professional-availability");
    },
    goToProfile() {
      let professionalId;
      if ("professional" in this.userInfo) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    readBookings() {
      if ("professional" in this.userInfo) {
        this.bookingModel.bookingProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.bookingModel.bookingProfessionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "booking/readBookingByProfessionalId",
        this.bookingModel
      );
    }
  },
  mounted() {
    this.readCustomerModel.customerId = this.customerId;
    StoreUtils.dispatch(
      StoreUtils.actions.customer.READ_BY_CUSTOMER,
      this.readCustomerModel
    );
    this.readBookings();
  }
};
</script>

<style scoped></style>
